export const ClockIcon = () => (
    <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#666"
            d="M9 3a.376.376 0 0 0-.375.375v2.25c0 .206.169.375.375.375a.376.376 0 0 0 .375-.375v-1.86A5.25 5.25 0 0 1 9 14.25a5.25 5.25 0 0 1-3.713-8.963.376.376 0 0 0 0-.53.376.376 0 0 0-.53 0A6 6 0 1 0 15 9a6 6 0 0 0-5.999-5.999ZM7.015 6.485a.376.376 0 0 0-.53 0 .376.376 0 0 0 0 .53l2.25 2.25a.376.376 0 0 0 .53 0 .376.376 0 0 0 0-.53l-2.25-2.25Z"
        />
    </svg>
);
